import React, { memo } from 'react';
export function ProblemSection() {
  const problems = ['You take a lot of photos, but very few feel truly special', 'Your dog moves before you get the shot', 'You never know what angle looks best', 'Indoor photos come out dark, flat, or disappointing', 'Outdoor photos feel random or cluttered', 'You want beautiful memories, but your results are inconsistent'];
  return <section className="bg-warm-mid py-10 md:py-20 px-4" data-id="element-255">
      <div className="max-w-3xl mx-auto" data-id="element-256">
        {/* Heading */}
        <h2 className="font-serif text-[1.6rem] md:text-4xl lg:text-5xl font-bold text-center text-warm-hero mb-2 md:mb-4 leading-[1.1]" data-id="element-257">
          If you are a dog owner, this{' '}
          <span className="italic text-soft-gold" data-id="element-258">will feel familiar</span>
        </h2>

        <p className="font-sans text-[14px] md:text-lg text-center text-gray-700 mb-5 md:mb-8 max-w-2xl mx-auto" data-id="element-259"></p>

        {/* Problem list */}
        <div className="bg-white p-5 md:p-8 rounded-2xl shadow-lg border border-orange/15 mb-6 md:mb-8" data-id="element-260">
          <ul className="space-y-3 md:space-y-4" data-id="element-261">
            {problems.map((item, index) => <li key={index} className="flex items-start" data-id="element-262">
                <span className="text-red-500 mr-3 text-base md:text-lg mt-0.5 flex-shrink-0" data-id="element-263">
                  ❌
                </span>
                <span className="font-sans text-[15px] md:text-lg text-gray-700" data-id="element-264">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>

        {/* Closing statement */}
        <div className="text-center max-w-2xl mx-auto" data-id="element-265">
          <p className="font-serif italic text-lg md:text-xl text-warm-hero font-medium" data-id="element-266">
            "I know my dog is adorable… I just wish I knew how to capture it
            better."
          </p>
        </div>
      </div>
    </section>;
}